import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { WalletServiceAutocompleteResponse } from '@/repositories/generated';

const response: WalletServiceAutocompleteResponse[] = [
  {
    id: '001',
    name: 'モックWS1',
    bonusExpiredFlg: true,
  },
  {
    id: '002',
    name: 'モックWS2',
    bonusExpiredFlg: false,
  },
  {
    id: '003',
    name: 'モックWS3',
    bonusExpiredFlg: true,
  },
  {
    id: '55',
    name: 'モックウォレットサービス５',
    bonusExpiredFlg: true,
  },
];

export const autocompleteWalletService = http.get(
  createMockEndpoint('/autocomplete/wallet_service'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
